import VueFormGenerator from "vue-form-generator";
import FieldBvmCheckbox from "./fieldBvmCheckbox";

export const customVueFormFields = {
  FieldBvmCheckbox
};

export function registerVueFormValidators(Vue) {
  Vue.use(VueFormGenerator, {
    validators: {
      bvmCheckboxXOR: function(value, field, model) {
        const errors = [];
        if (value && model[field.xorFieldCheck]) {
          errors.push(field.xorErrorMessage);
        }
        return errors;
      }
    }
  });
}
